/**
 * Copyright (c) 2010-2026 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Store } from '@ngxs/store';
import { Options } from 'ol/interaction/Pointer';
import { StyleLike } from 'ol/style/Style';
import { FlatStyleLike } from 'ol/style/flat';

export interface MeasureOptions extends Options {
    clickTolerance?: number;
    snapClosed?: boolean;
    displayUnits?: MeasureUnit;
    style?: StyleLike | FlatStyleLike;
    store: Store;
}

export type MeasureUnit = 'm' | 'km' | 'sqm' | 'sqkm' | 'ft' | 'mi' | 'sqft' | 'sqmi' | 'acre';

export const MeasureEventType = {
    START: 'measurestart',
    CLEAR: 'measureclear',
    END: 'measureend',
    CHANGE: 'measurechange'
};